import { render, staticRenderFns } from "./PromocodeModal.vue?vue&type=template&id=1fe589ff&scoped=true"
import script from "./PromocodeModal.vue?vue&type=script&lang=js"
export * from "./PromocodeModal.vue?vue&type=script&lang=js"
import style0 from "./PromocodeModal.vue?vue&type=style&index=0&id=1fe589ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe589ff",
  null
  
)

export default component.exports